module.exports = __webpack_public_path__ + "media/images/flags/us-efbfef90cf4d0c8367298e9b55b6f718.jpg";